import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {HttpService} from "../../services/http.service";
import { ChatService } from '../../services/chat.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss']
})
export class BalanceComponent implements OnInit {
  balance = '';
  reload = false;
  constructor(private location: Location,
              private http: HttpService,
              private authService: AuthService) { }

  ngOnInit(): void {

  }

  submit() {
    this.reload = true;
    this.http.getBalance().pipe().subscribe(x => {
      this.balance = x.Balance;
      this.reload = false;

    }, error => {
      this.reload = false;
    });
  }

  back() {
    this.location.back();
  }
}
